module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_app_testing-61556dac575e9300b3b2f417a031a313.svg";